import { render, staticRenderFns } from "./ordini_attivi_mobile.vue?vue&type=template&id=21298072&scoped=true&"
import script from "./ordini_attivi_mobile.vue?vue&type=script&lang=js&"
export * from "./ordini_attivi_mobile.vue?vue&type=script&lang=js&"
import style0 from "./ordini_attivi_mobile.vue?vue&type=style&index=0&id=21298072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21298072",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VDivider,VIcon,VList})
